import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter, map, startWith } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HeaderActiveRouteService {
  public activeHeaderRoute$: Observable<HeaderActiveRoute>;

  constructor(private router: Router) {
      this.activeHeaderRoute$ = router.events.pipe(
          filter(e => e instanceof NavigationEnd),
          startWith(this.router.url),
          map(() => router.url),
          map((url) => parseUrl(url)),
      );
  }

}

export enum HeaderActiveRoute {
    Navigator,
    DataImport,
    Surveys,
    Interviews,
    Reports,
    Documents,
    Insights,
    Unknown,
}

function parseUrl(url: string) {
    const navigatorRoute = /study\/\d+\/home/;
    if (navigatorRoute.test(url)) {
        return HeaderActiveRoute.Navigator;
    }

    const dataImportRoute = /study\/\d+\/data-import/;
    if (dataImportRoute.test(url)) {
        return HeaderActiveRoute.DataImport;
    }

    const surveysRoute = /study\/\d+\/surveys/;
    if (surveysRoute.test(url)) {
        return HeaderActiveRoute.Surveys;
    }

    const interviewsRoute = /study\/\d+\/scheduling-tool/;
    if (interviewsRoute.test(url)) {
        return HeaderActiveRoute.Interviews;
    }

    const reportsRoute = /study\/\d+\/reports/;
    if (reportsRoute.test(url)){
        return HeaderActiveRoute.Reports;
    }

    const documentsRoute = /study\/\d+\/manage-documents/;
    if (documentsRoute.test(url)) {
        return HeaderActiveRoute.Documents;
    }

    const insightsRoute = /study\/\d+\/dashboard-insights/;
    if (insightsRoute.test(url)){
        return HeaderActiveRoute.Insights;
    }

    return HeaderActiveRoute.Unknown;
}
